import { render, staticRenderFns } from "./ThreadTopicTitle.vue?vue&type=template&id=3d91e65f&scoped=true"
import script from "./ThreadTopicTitle.vue?vue&type=script&lang=ts"
export * from "./ThreadTopicTitle.vue?vue&type=script&lang=ts"
import style0 from "./ThreadTopicTitle.vue?vue&type=style&index=0&id=3d91e65f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d91e65f",
  null
  
)

export default component.exports